import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getChat } from '../AIClients/aiClientData';

const NO_HIGHLIGHT = [];

// 사례개념화를 쓰는 동안 참고하는 면담 대화 기록. highlightIndexes(대화 순번)는 피드백 근거로 표시한다.
export default function CaseTranscriptPanel({ saved, clientName = '내담자', highlightIndexes = NO_HIGHLIGHT }) {
    const id = saved?.id;
    const token = saved?.token;
    const [messages, setMessages] = useState(null);
    const [error, setError] = useState('');
    const logRef = useRef(null);

    // 저장된 면담의 대화 목록을 불러온다. 근거 순번과 맞추기 위해 원래 순번을 함께 둔다.
    const load = useCallback(async () => {
        setError('');
        try {
            const chat = await getChat(id, token);
            setMessages(chat.messages.map((message, index) => ({ ...message, index })).filter(message => message.content));
        } catch (failure) {
            setError(failure.message);
        }
    }, [id, token]);

    useEffect(() => { if (id && token) load(); }, [id, token, load]);

    // 근거 대화가 바뀌면 첫 근거가 보이도록 기록 안에서만 스크롤한다.
    useEffect(() => {
        const log = logRef.current;
        const first = log?.querySelector('.evidence');
        if (first) log.scrollTop = first.offsetTop - 8;
    }, [highlightIndexes, messages]);

    return <aside className="review-card case-transcript" aria-labelledby="case-transcript-title">
        <span className="ai-kicker">TRANSCRIPT</span>
        <h2 id="case-transcript-title">면담 기록</h2>
        {!id && <p className="ai-small">저장된 면담이 없어 대화 기록을 보여줄 수 없습니다.</p>}
        {error && <div className="ai-alert" role="alert">{error} <button type="button" onClick={load}>다시 시도</button></div>}
        {id && !error && !messages && <p className="ai-small" role="status">대화 기록을 불러오고 있습니다.</p>}
        {messages?.length === 0 && <p className="ai-small">아직 나눈 대화가 없습니다.</p>}
        {messages?.length > 0 && <div className="case-transcript-log" role="log" aria-label="면담 대화 기록" ref={logRef}>
            {messages.map(message => {
                const evidence = highlightIndexes.includes(message.index);
                return <div key={message.id} className={`${message.role === 'user' ? 'counselor' : 'client'}${evidence ? ' evidence' : ''}`}>
                    <strong>{message.role === 'user' ? '나 · 상담자' : clientName}{evidence && <span className="case-evidence-tag"> · 피드백 근거</span>}</strong><p>{message.content}</p>
                </div>;
            })}
        </div>}
    </aside>;
}

CaseTranscriptPanel.propTypes = {
    saved: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), token: PropTypes.string }),
    clientName: PropTypes.string,
    highlightIndexes: PropTypes.arrayOf(PropTypes.number),
};
